// assets
import { IconPlugConnected } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| INTEGRATIONS MENU ITEM ||============================== //

const icons = {
  IconPlugConnected
};

const integrations: NavItemType = {
  id: 'integrations',
  title: 'integrations',
  icon: icons.IconPlugConnected,
  type: 'group',
  url: '/integrations'
};

export default integrations;
